import { GenexSISModel } from "@/models/sis/GenexSISModel";
import { normalize } from "@/utils/data";

export default class ApplicationFields extends GenexSISModel {
  static entity = "application_fields";

  static fields() {
    return {
      id: this.attr(null),
      category_id: this.attr(null),
      field: this.attr(null),
      title: this.attr(null),
      visible: this.attr(null),
      mandatory: this.attr(null),
      order: this.attr(null),
    };
  }

  /**
   * @param {Object} pagination
   * @param {number} pagination.page page number
   * @param {number} pagination.limit page limit
   * @param {Object} query query object
   * @param {Array} relationship relationship array
   * @returns promise of all application fields
   */
  static FetchAll({ page = 1, limit = 999 }, query = {}, relationship = []) {
    return this.GenexAxiosGet("ApplicationFields.FetchAll", `/application-fields`, {
      params: {
        ...{
          page: page,
          limit: limit,
          with: relationship,
        },
        ...(Object.keys(query).length > 0 ? query : {}),
      },
      dataTransformer: ({ data: { data } }) => {
        return normalize(data);
      },
    });
  }

  /**
   * @param {Object} application_fields object of fields to store
   * @returns promise of stored fields
   */
  static Update(application_fields) {
    return this.GenexAxiosPatch("ApplicationFields.Update", `/application-fields/bulk`, application_fields, {
      dataTransformer: ({ data: { data } }) => {
        return normalize(data);
      },
    });
  }
}
